import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { Box, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import "../styles/Table.css"
import { useNavigate } from 'react-router-dom';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';


// const useStyles = makeStyles({
//   root: {
//     width: '100%',
//   },
//   container: {
//     maxHeight: 440,
//   },
// });

const useStyles = makeStyles((theme) => ({
  container: {
    maxHeight: 450,
  },
  header: {
    backgroundColor: '#36454F', // You can change this to any color you like
    color: '#fff',
    fontWeight: 'bold',
    padding: theme.spacing(2),
    lineHeight: '1.2',
    borderBottom: '2px solid #ddd'
  },
  alternateRowLight: {
    backgroundColor: '#f9f9f9',
  },
  alternateRowDark: {
    backgroundColor: '#e0e0e0',
  },
  // cell: {
  //   padding: theme.spacing(1),
  //   textAlign: 'center',
  // },
  cell: {
    padding: theme.spacing(1),
    textAlign: 'center',
    borderRight: '1px solid #ddd',  // Add right border to each cell
    borderBottom: '1px solid #ddd',  // Add bottom border to each row
  },
  lastCell: {
    borderRight: 'none',  // No right border for the last cell
  },
  row: {
    '&:last-child td': {
      borderBottom: 'none',  // No bottom border for the last row
    },
  },
}));

const isOverdue = (date) => {
  const today = new Date();
  const dueDate = new Date(date);
  return dueDate < today;
};

export default function StickyHeadTable({ data, columns, fetchData = async () => { }, totalRecords = 0, isServerSide = false, pagination = true, downloadFile }) {

  console.log("Data In Table Component:", data);
  const navigate = useNavigate();
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [loading, setLoading] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    const loadingData = async () => {
      await fetchData(page, rowsPerPage);
      setLoading(false);
    };
    loadingData();
  }, [fetchData, page, rowsPerPage])

  // useEffect(() => {
  //   // Fetch data based on page and rows per page
  //   fetchData(page, rowsPerPage);
  // }, [fetchData, page, rowsPerPage]);

  const handleEdit = (row) => {
    console.log("Edit row:", row);
    if ('disposal_type' in row) {
      navigate(`/asset-disposal-details/${row.id}`);
    } else if ('new_vendor_name' in row) {
      navigate(`/asset-transfer-details/${row.id}`);
    } else if ('submitby_dept' in row) {
      navigate(`/pli-details/${row.id}`);
    } else {
      // Optionally handle cases where none of the keys match
      console.warn("No valid key found for navigation:", row);
    }
  };
  // const handleTransfer = (row) => {
  //   console.log("Edit row:", row.SrNo);
  //   navigate(`/asset-transfer-form/${row.SrNo}`);

  // };


  // const handleDownload = (row) => {
  //   // Logic for handling the download action
  //   console.log("Downloading file for: ", row);
  //   // Example: initiate a file download
  //   const fileUrl = row.fileUrl; // Assuming you have a file URL in the row
  //   const link = document.createElement('a');
  //   link.href = fileUrl;
  //   link.download = `file_${row.id}.pdf`; // Set the filename for download
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  if (loading) {
    return (
      <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
        <GridLoadingSpinner />
      </Box>
    );
  }

  return (
    <>
      <Paper className={classes.root}>
        {/* <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data && (isServerSide ? data : data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)).map((row, rowIndex) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                    {columns.map((column) => {
                      let value;
                      if (column.id === 'Sr.no') {
                        value = rowIndex + 1;
                      } else if (column.id.includes('.')) {
                        value = column.id.split('.').reduce((acc, key) => (acc && acc[key] !== undefined) ? acc[key] : undefined, row);
                      } else {
                        value = row[column.id];
                      }

                      return (
                        <TableCell key={column.id} align={column.align}
                          style={column.id === 'nextDueDate' && isOverdue(value) ? { color: 'red' } : {}}>
                          {column.id === 'Action' ? (
                            <>
                              <IconButton aria-label="edit" onClick={() => handleEdit(row)}>
                                <EditIcon />
                              </IconButton>
                              <IconButton aria-label="transfer" onClick={() => handleTransfer(row)}>
                                <TransferWithinAStationIcon />
                              </IconButton>
                            </>
                          ) : column.id === 'TransferStatus' ? (
                            <div className="status-cell">
                              {value}
                              <div className={`status-bar ${value === 'Approved' ? 'green-status' : 'red-status'}`}></div>
                            </div>
                          ) : (
                            column.format && typeof value === 'number' ? column.format(value) : value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>

          </Table>
        </TableContainer> */}
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className={classes.header}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data && (isServerSide ? data : data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)).map((row, rowIndex) => {
                return (
                  <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={rowIndex}
                    className={rowIndex % 2 === 0 ? classes.alternateRowLight : classes.alternateRowDark}
                  >
                    {columns.map((column) => {
                      let value;
                      if (column.id === 'Sr.no') {
                        value = rowIndex + 1;
                      } else if (column.id.includes('.')) {
                        value = column.id.split('.').reduce((acc, key) => (acc && acc[key] !== undefined) ? acc[key] : undefined, row);
                      } else {
                        value = row[column.id];
                      }

                      return (
                        <TableCell key={column.id} align={column.align} className={classes.cell}
                          style={column.id === 'nextDueDate' && isOverdue(value) ? { color: 'red' } : {}}
                        >
                          {/* Add the download icon in the 'Download' column */}
                          {column.id === 'download' ? (
                            <IconButton aria-label="download" onClick={() => downloadFile(row.id)}>
                              <GetAppIcon />
                            </IconButton>
                          ) : column.id === 'Action' ? (
                            <>
                              <IconButton aria-label="edit" onClick={() => handleEdit(row)}>
                                <VisibilityIcon />
                              </IconButton>
                            </>
                          ) : column.id === 'NewSupplierAcknowledge' ? (
                            <div className="status-cell">
                              {value}
                              <div className={`status-bar ${row.status === 'Supplier Approve' ? 'green-status' : 'red-status'}`}></div>
                            </div>
                          ) : (
                            column.format && typeof value === 'number' ? column.format(value) : value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {pagination && <TablePagination
          rowsPerPageOptions={[50, 100, 500]}
          component="div"
          // count={data && data.length}
          count={isServerSide ? totalRecords : (data?.length ?? 0)}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />}
      </Paper>
    </>

  );
}
